import React from 'react';

export const Context = React.createContext();

export const UserContext = React.createContext();

export const KpiContext = React.createContext();